import { TimekeeperService } from "services/TimekeeperService";

const tk  = new TimekeeperService();

const gettingOvertime = async (setLoading, setRows) => {
    setLoading(true);

    tk.overtime.getOvertimes()
    .then((response) => {
        const rows = response.map((overtime) => (
            {
                id: overtime.overtime_rule_id,
                name: overtime.name,
                overtime_start: overtime.overtime_start,
                min_hour_calification: overtime.min_hour_calification,
                required_approval: overtime.required_approval
            }
        ))

        setRows(rows)
    })
    .catch((error) => {
        console.error(error.message);
    })
    .finally(() => {
        setLoading(false);
    });
}

const gettingOvertimebyId = async (setLoading, id) => {
    setLoading(true);
    return await tk.overtime.getById(id)
}

const editOvertime = async (id, edit_overtime) => {
    return await tk.overtime.updateOvertime(id, edit_overtime);
}

const deleteOvertime = async (setLoading, id) => {
    setLoading(true);
    return await tk.overtime.deleteOvertime(id);
}

export {
    gettingOvertime,
    // createOvertime,
    gettingOvertimebyId,
    editOvertime,
    deleteOvertime
}